<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction"></popup>
        <form>
            <div class="inner">
                <add-button
                    v-if="$_createActionAllowed"
                        :title="'Přidat zdroj obsahu' | translate"
                        route-name="contentSourceNew">
                </add-button>
                <h1 v-translate>Zdroje obsahu</h1>
            </div>
            <div class="inner_white">
                <div class="filter">
                    <div class="field_left">
                        <search-input input-class="search" v-model="formFields.search"></search-input>
                    </div>
                    <div class="field_right">
                        <filter-checkbox
                                id="virtual"
                                name="virtual"
                                val="virtual"
                                v-model="formFields.physical"
                        ><translate class="translate">Fyzický zdroj</translate>
                        </filter-checkbox>
                    </div>
                  <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
                </div>
                <form>
                    <div class="table_overflow">
                        <table class="vypis vypis_detail" ref="table_with_action_line" v-show="dataLoaded">
                        <thead>
                        <tr>
                            <th class="no_padding drag_drop"></th>
                            <th class="no_padding checkbox"></th>
                            <sorting-table-title
                                    v-for="title in sortingTableTitles"
                                    :key="title.id"
                                    :column="title.column"
                                    :sortable="title.sortable"
                                    :sort="getActiveSort(title.column)"
                                    @changeSorting="changeSorting"
                            >{{ title.name }}
                            </sorting-table-title>
                            <th class="no_padding edit"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <content-source-row
                                v-for="entity in entities"
                                :entity="entity"
                                :key="entity.id"
                                :selectedEntities="selectedEntities"
                                :protocols-by-id="protocolsById"
                                ref="content_source_row"
                                @input="select"
                                @updateEntity="updateEntity"
                                @deleteEntity="deleteEntity"
                        ></content-source-row>
                        </tbody>
                    </table>
                    </div>
                    <list-action-line
                            :entities="entities"
                            :selected-entities="filteredSelectedEntities"
                            :multiple-action-options="multipleActionOptions"
                            :offset="formFields.offset"
                            :limit="formFields.limit"
                            :total-count="totalCount"
                            @select-all="toggleSelectAll"
                            @run-multiple-action="runMultipleAction"
                            @limit="setLimit"
                            @offset="setOffset"
                            ref="action_line"
                    ></list-action-line>
                </form>
            </div>
        </form>
    </div>
</template>

<script>
	import ContentSourceRow from "@/components/views/contentsources/ContentSourceRow"
	import listActions from "@/components/mixins/list-actions"

	export default {
		name: "ContentSourceList",
		components: {ContentSourceRow},
		mixins: [listActions],
		data() {
			return {
				moduleName: 'contentSources',
                entitiesKey: 'content_sources',
                formFields: {
                    sort: {
                        column: 'sHostname',
						direction: 'asc'
                    },
                    physical: 0
                },
                protocolsById: {},
			}
		},
		created(ContentSourceService, ProtocolService) {
			this.entityService = ContentSourceService
            this.protocolService = ProtocolService

			this.createdInit()
      this.protocolService.getSimpleEntities()
          .then(data => {
            this.protocolsById = this._.mapKeys(data['protocols'], function (item) {
              return item['id']
            })
          })
		},
		computed: {
            multipleActionOptions() {
              return [
                {value: 'choose', text: this.$gettext('Vyberte akci')},
                {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
              ]
            },
            sortingTableTitlesOperator() {
                return [
                    {id: 1, name: this.$gettext('Název zdroje'), column: 'sHostname'},
                    {id: 2, name: this.$gettext('IP adresa'), column: 'sIp'},
                    {id: 3, name: this.$gettext('Virtuální zdroj'), column: 'sVirtual'},
                    {id: 4, name: this.$gettext('Lineární obsah'), column: 'sLinearContent', sortable: false},
                    {id: 5, name: this.$gettext('TimeShift'), column: 'sTimeshift', sortable: false},
                    {id: 6, name: this.$gettext('Catchup'), column: 'sCatchup', srotable: false},
                    {id: 7, name: this.$gettext('PVR'), column: 'sPvr', sortable: false},
                ]
            },
            sortingTableTitlesOwner() {
                return [
                    {id: 1, name: this.$gettext('Název zdroje'), column: 'sHostname'},
                    {id: 2, name: this.$gettext('Operátor'), column: 'sOperator'},
                    {id: 3, name: this.$gettext('IP adresa'), column: 'sIp'},
                    {id: 4, name: this.$gettext('Virtuální zdroj'), column: 'sVirtual'},
                    {id: 5, name: this.$gettext('Lineární obsah'), column: 'sLinearContent', sortable: false},
                    {id: 6, name: this.$gettext('TimeShift'), column: 'sTimeshift', sortable: false},
                    {id: 7, name: this.$gettext('Catchup'), column: 'sCatchup', srotable: false},
                    {id: 8, name: this.$gettext('PVR'), column: 'sPvr', sortable: false},
                ]
            },
			sortingTableTitles() {
				if (this.$_readActionAllowedAllOrOwnAndGlobal) {
					return this.sortingTableTitlesOwner
				} else {
					return this.sortingTableTitlesOperator
				}
			},
      csvHeaders(){
        let headers = this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
        if(headers.hasOwnProperty("operator")){
          headers.operator.callback = entity => {return entity.operator_name};
        }
        headers.virtual.callback = entity => {return entity.virtual ? this.$gettext('Ano') : this.$gettext('Ne')};
        headers.linear_content.callback = (entity, index) => {return this.$refs.content_source_row[index].linearContentProtocols(); };
        headers.timeshift.callback = (entity, index) => {return this.mapNonlinearDataForCsv(this.$refs.content_source_row[index].timeshiftProtocols()); };
        headers.catchup.callback = (entity, index) => {return this.mapNonlinearDataForCsv(this.$refs.content_source_row[index].catchupProtocols()); };
        headers.pvr.callback = (entity, index) => {return this.mapNonlinearDataForCsv(this.$refs.content_source_row[index].pvrProtocols()); };

        return headers;
      },
		},
		methods: {
      mapNonlinearDataForCsv(data){
        return data.map((item) =>{return item.name}).join(', ');
      },
			loadAdditionalDefaults() {
				let anyChanges = false
				if (this.loadDefaultByKey('physical') && this.formFields.physical !== 0) {
					anyChanges = true
				}
				return anyChanges
			},
			saveFilterValues() {
				this.saveSearch(this.formFields.search)
				this.setUserSetting('physical', this.formFields.physical)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/ContentSourceList.vue